// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

/* eslint-disable */

/**
 * This is a automatically generated component, do not edit it.
 * If you need to edit this component, move it to some other folder.
 */

import React from 'react';
function DrugIcon14(props: React.SVGProps<SVGSVGElement>): React.ReactElement {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={32}
      height={32}
      viewBox="0 0 32 32"
      fill="none"
      {...props}
    >
      <g
        fill="currentColor"
        clipPath="url(#a)"
      >
        <path d="M14.076 18.02a.339.339 0 1 0 .667-.12 4.706 4.706 0 0 0-1.687-2.81.334.334 0 1 0-.416.524 4 4 0 0 1 1.436 2.406ZM10.11 20.424a2.06 2.06 0 1 0 0 4.12 2.06 2.06 0 0 0 0-4.12Zm0 3.453a1.393 1.393 0 1 1 .001-2.787 1.393 1.393 0 0 1 0 2.787Z" />
        <path d="M27.404 23.843a3.434 3.434 0 0 0-2.403-1.263 1.094 1.094 0 0 1-.88-.514 3.616 3.616 0 0 1-.507-1.85v-2.55a.334.334 0 0 0-.666 0v2.544c0 .77.207 1.527.6 2.19a1.76 1.76 0 0 0 1.406.836 2.769 2.769 0 0 1 1.919 4.488 2.765 2.765 0 0 1-3.239.816 4 4 0 0 0 .737-1.404.618.618 0 0 1 .813-.41l.637.237a.333.333 0 0 0 .43-.197.332.332 0 0 0-.197-.433l-.636-.24a1.288 1.288 0 0 0-1.687.85 3.396 3.396 0 0 1-6.513 0 1.29 1.29 0 0 0-1.687-.85l-.64.24a.334.334 0 0 0 .233.623l.64-.236a.619.619 0 0 1 .814.41c.147.511.396.988.733 1.4A2.764 2.764 0 1 1 16 23.243a1.752 1.752 0 0 0 1.403-.837c.392-.663.598-1.42.597-2.19v-2.55a.334.334 0 0 0-.667 0v2.544a3.621 3.621 0 0 1-.5 1.856 1 1 0 0 1-.453.397v-2.4a.8.8 0 0 0-.177-.507v-.793a6.045 6.045 0 0 0-2.436-4.873 1.334 1.334 0 0 0-.31-.167v-1.15h.103a.916.916 0 0 0 .923-.907v-.333a.917.917 0 0 0-.916-.917h-.494c0-2.183-.226-3.223-.98-8.7a2 2 0 0 0-3.97 0c-.78 5.667-.966 6.587-.98 8.7h-.476a.916.916 0 0 0-.934.917v.333a.917.917 0 0 0 .934.907h.103v1.15c-.11.042-.215.098-.31.167A6.043 6.043 0 0 0 4 18.763v.797a.783.783 0 0 0-.177.503v7.334c0 .182.063.36.177.503v2.786A1.334 1.334 0 0 0 5.334 32h9.557a1.334 1.334 0 0 0 1.313-1.314V29.43a3.37 3.37 0 0 0 1.587-.384 4.06 4.06 0 0 0 5.363 0 3.43 3.43 0 0 0 4.25-5.203ZM4.648 27.54a.147.147 0 0 1-.144-.147v-1.577h8.284c-.036.596.086 1.19.353 1.724H4.648Zm8.24-2.39H4.504c0-5.607-.026-5.134.064-5.204.09-.07-.694-.026 11-.026a.146.146 0 0 1 .143.143v2.547a3.43 3.43 0 0 0-2.823 2.54ZM8.784 1.816a1.333 1.333 0 0 1 2.65 0c.777 5.667.964 6.57.974 8.61h-.777c-.073-1.093-.15-1.56-.333-3.02a1.187 1.187 0 0 0-.837-.966V3.473a.333.333 0 1 0-.667 0V6.44a1.187 1.187 0 0 0-.84.966c-.193 1.424-.276 1.924-.333 3.02h-.813c.013-2.063.21-3.033.976-8.606v-.004Zm1.334 5.237a.52.52 0 0 1 .51.443c.183 1.35.28 1.947.333 2.93H9.25c.067-1 .163-1.586.333-2.93a.52.52 0 0 1 .527-.44l.007-.003ZM6.4 11.666v-.333a.253.253 0 0 1 .25-.25h6.917a.254.254 0 0 1 .25.25v.333a.25.25 0 0 1-.25.247h-6.9a.25.25 0 0 1-.267-.247Zm6.397.914v1.053H7.42L7.4 12.58h5.397ZM6.85 14.423a.697.697 0 0 1 .417-.13h5.683a.697.697 0 0 1 .417.13 5.386 5.386 0 0 1 2.17 4.333v.49H4.668v-.483a5.387 5.387 0 0 1 2.183-4.34Zm8.04 16.91H5.334a.648.648 0 0 1-.666-.647v-2.48h8.91a3.362 3.362 0 0 0 1.96 1.16V30.7a.647.647 0 0 1-.647.633Z" />
      </g>
      <defs>
        <clipPath id="a">
          <path
            fill="#fff"
            d="M0 0h32v32H0z"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
export default DrugIcon14;
